<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-md-4">
            <table>
              <tr>
                <td><a disabled @click="exportReport()" class="btn-primary mr-5"><i class="far fa-file-alt mr-5"></i>Export</a></td>
                <td>
                  <flat-pickr @on-change="changeDate" :config="exportConfig" class="font-13" v-model="exportDates" name="export_date_start"></flat-pickr>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Branch
              </div>
              <div class="col-sm-8">
                <b-form-select name="branch" v-model="branch_id" @change="changeBranch">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Studio
              </div>
              <div class="col-sm-8">
                <b-form-select name="studio" v-validate="'required'" @change="changeStudio" v-model="studio_id">
                  <option value="">Please select</option>
                  <option v-for="item in optStudio" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table class="table-comission" @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive :items="items" :fields="fields" :current-page="currentPage">
<!--          <template slot="employeeID" slot-scope="data">-->
          <template v-slot:cell(employeeID)="data">
            {{data.item.personal_training.branch.codename}}{{data.item.personal_training.id}}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
          :total-pages="totalPage"
          @page-changed="pageOneChanged"
          prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import moment from 'moment'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'gfCommision',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'employee_id',
          label: 'Employee ID',
          sortable: true
        },
        {
          key: 'name',
          label: 'Employee Name',
          formatter: (value, key, item) => {
            return item.user && item.user.member ? item.user.member.first_name + ' ' + item.user.member.last_name : '-'
          },
          sortable: true
        },
        {
          key: 'studio',
          label: 'Studio',
          formatter: (value, key, item) => {
            return item.studio ? item.studio.name : '-'
          },
          sortable: false
        },
        {
          key: 'class_name',
          label: 'Class Name',
          sortable: false
        },
        {
          key: 'attendance_date',
          label: 'Date',
          formatter: (value, key, item) => {
            return moment(item.attendance_date).format('DD MMMM YYYY')
          },
          sortable: false
        },
        {
          key: 'classes_schedule',
          label: 'Class Time',
          formatter: (value, key, item) => {
            return item.classes_schedule && item.classes_schedule.classes_time ? (item.classes_schedule.classes_time.time_start).slice(0,-3) + ' - ' + (item.classes_schedule.classes_time.time_end).slice(0,-3) : '-'
          },
          sortable: false
        },
        {
          key: 'class_duration',
          label: 'Class Duration',
          sortable: false
        },
        {
          key: 'attendance_time',
          label: 'Instructor Time',
          formatter: (value, key, item) => {
            return (item.attendance_time_in ? (item.attendance_time_in).slice(0,-3) : '') + ' - ' + (item.attendance_time_out ? (item.attendance_time_out).slice(0,-3) : '')
          },
          sortable: false
        },
        {
          key: 'comission',
          label: 'Comission (Rp)',
          formatter: (value, key, item) => {
            return 'Rp. ' + parseFloat(item.comission).toLocaleString('id-ID', {maximumFractionDigits:2})
          },
          sortable: false
        },

      ],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      exportDates: (moment().startOf('month').format('YYYY-MM-DD'))+' to '+(moment().endOf('month').format('YYYY-MM-DD')),
      exportConfig: {
        mode: "range",
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/y",
        defaultDate: [(moment().startOf('month').format('YYYY-MM-DD')), (moment().endOf('month').format('YYYY-MM-DD'))]
      },
      items: [],
      dataBranch: [],
      branch_id: null,
      getId: Auth.Session.get().paradigm_id,
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      studio_id: '',
      optStudio: [],
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    changeStudio (event) {
      this.fetchData()
    },
    changeDate(selectedDates, dateStr, instance) {
      this.exportDates = dateStr
      if(this.exportDates.includes(" to ") === true) {
        this.fetchData()
      }
    },
    parseCalc (event) {
      return Math.ceil(event)
    },
    parseDate (value) {
      moment.locale('en')
      return moment(value).format('DD MMMM YYYY')
    },
    parseTime (value) {
      moment.locale('en')
      return moment(value).format('h:mm a')
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
      } else {
        this.sortType = 'desc'
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editForm (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteForm(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/form/'.concat(event)).then(response => {
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    exportReport() {
      let dates = this.exportDates.split(' to ')
      let url = 'fitness/v1/export/comission?start_date='+dates[0]
        +'&end_date='+dates[1]
        +'&group_fitness_id='+Auth.Session.get().paradigm_id

      if (this.studio_id != "") {
        url += '&studio_id=' + this.studio_id
      }

      axios({
        method: 'get',
        url: url,
        responseType: 'arraybuffer'
      }).then(response => {
        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Group Fitness Comission '+moment(dates[0]).format('DD-MMM-YYYY')+' - '+moment(dates[1]).format('DD-MMM-YYYY')+'.xlsx'
        link.click()
      }).catch(error => {
        console.log('error', error)
      })
    },
    changeBranch(event) {
      this.studio_id = ""
      let url = 'fitness/v1/studio?sorting=id&sorting_type=asc&status=active'

      if (event != "") {
        url += '&branch_id=' + event
      }

      axios.get(url).then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      let dates1 = this.exportDates.split(' to ')
      let url_studio = 'fitness/v1/studio?sorting=id&sorting_type=asc&status=active'
      // let url_comission = 'fitness/v1/group_fitness/comission?group_fitness_id=' + Auth.Session.get().paradigm_id
      //   + '&start_date=' + dates1[0]
      //   + '&end_date=' + dates1[1]
      //   + '&page=' + this.currentPage
      //   + '&limit=' + this.paginationLimit
      //   + '&sorting=' + this.sortBy
      //   + '&sorting_type=' + this.sortType
      //   + '&keyword=' + this.searchData
      let url_comission = 'fitness/v1/group_fitness/comission?start_date=' + dates1[0]
        + '&end_date=' + dates1[1]
        + '&page=' + this.currentPage
        + '&limit=' + this.paginationLimit
        + '&sorting=' + this.sortBy
        + '&sorting_type=' + this.sortType
        + '&keyword=' + this.searchData

      if (this.studio_id != "") {
        url_comission += '&studio_id=' + this.studio_id
      }

      axios.get(url_comission).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })

      if (this.branch_id != "") {
        url_studio += '&branch_id=' + this.branch_id
      }

      axios.get(url_studio).then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })

      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
